import Icon, { IconBaseProps } from '@ant-design/icons/lib/components/Icon';

import BellOutlined from '@ant-design/icons/lib/icons/BellOutlined';
import CameraOutlined from '@ant-design/icons/lib/icons/CameraOutlined';
import CheckCircleFilled from '@ant-design/icons/lib/icons/CheckCircleFilled';
import CheckCircleOutlined from '@ant-design/icons/lib/icons/CheckCircleOutlined';
import ClockCircleOutlined from '@ant-design/icons/lib/icons/ClockCircleOutlined';
import EnvironmentOutlined from '@ant-design/icons/lib/icons/EnvironmentOutlined';
import EyeInvisibleOutlined from '@ant-design/icons/lib/icons/EyeInvisibleOutlined';
import EyeOutlined from '@ant-design/icons/lib/icons/EyeOutlined';
import GlobalOutlined from '@ant-design/icons/lib/icons/GlobalOutlined';
import LinkOutlined from '@ant-design/icons/lib/icons/LinkOutlined';
import LoadingOutlined from '@ant-design/icons/lib/icons/LoadingOutlined';
import LockOutlined from '@ant-design/icons/lib/icons/LockOutlined';
import MailOutlined from '@ant-design/icons/lib/icons/MailOutlined';
import MobileOutlined from '@ant-design/icons/lib/icons/MobileOutlined';
import NumberOutlined from '@ant-design/icons/lib/icons/NumberOutlined';
import PlusCircleOutlined from '@ant-design/icons/lib/icons/PlusCircleOutlined';
import QrcodeOutlined from '@ant-design/icons/lib/icons/QrcodeOutlined';
import QuestionCircleOutlined from '@ant-design/icons/lib/icons/QuestionCircleOutlined';
import SearchOutlined from '@ant-design/icons/lib/icons/SearchOutlined';
import StarOutlined from '@ant-design/icons/lib/icons/StarOutlined';
import UploadOutlined from '@ant-design/icons/lib/icons/UploadOutlined';
import UserOutlined from '@ant-design/icons/lib/icons/UserOutlined';
import CrownOutlined from '@ant-design/icons/lib/icons/CrownOutlined';
import CloseCircleOutlined from '@ant-design/icons/lib/icons/CloseCircleOutlined';
import {
  CheckOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
  LogoutOutlined,
  MinusOutlined,
  PlusOutlined,
} from '@ant-design/icons';

export function SearchIcon() {
  return <SearchOutlined />;
}

export function LockOutlinedIcon() {
  return <LockOutlined />;
}

export function UserIcon() {
  return <UserOutlined />;
}

export function CheckCircleOutlinedIcon() {
  return <CheckCircleOutlined />;
}

export function CameraOutlinedIcon() {
  return <CameraOutlined />;
}

export function EyeInvisibleOutlinedIcon() {
  return <EyeInvisibleOutlined />;
}

export function EyeOutlinedIcon() {
  return <EyeOutlined />;
}

export function CheckCircleFilledIcon() {
  return <CheckCircleFilled />;
}

export function QrcodeOutlinedIcon() {
  return <QrcodeOutlined />;
}

export function MobileOutlinedIcon() {
  return <MobileOutlined />;
}

export function NumberOutlinedIcon() {
  return <NumberOutlined />;
}

export function MailOutlinedIcon() {
  return <MailOutlined />;
}

export function GlobalOutlinedIcon() {
  return <GlobalOutlined />;
}

export function SearchOutlinedIcon() {
  return <SearchOutlined />;
}

export function BellOutlinedIcon() {
  return <BellOutlined />;
}

export function QuestionCircleOutlinedIcon() {
  return <QuestionCircleOutlined />;
}

export function LoadingOutlinedIcon() {
  return <LoadingOutlined />;
}

export function UploadOutlinedIcon() {
  return <UploadOutlined />;
}

export function LinkOutlinedIcon() {
  return <LinkOutlined />;
}

export function StarOutlinedIcon() {
  return <StarOutlined />;
}

export function ClockCircleOutlinedIcon() {
  return <ClockCircleOutlined />;
}

export function EnvironmentOutlinedIcon() {
  return <EnvironmentOutlined />;
}

export function PlusCircleOutlinedIcon() {
  return <PlusCircleOutlined />;
}

export function CrownOutlinedIcon() {
  return <CrownOutlined />;
}

export function DeleteOutlinedIcon() {
  return <DeleteOutlined />;
}

export function InfoCircleOutlinedIcon() {
  return <InfoCircleOutlined />;
}

export function MinusOutlinedIcon() {
  return <MinusOutlined />;
}

export function PlusOutlinedIcon() {
  return <PlusOutlined />;
}

export function LogoutOutlinedIcon() {
  return <LogoutOutlined />;
}

export function CheckOutlinedIcon() {
  return <CheckOutlined />;
}

export function CloseCircleOutlinedIcon() {
  return <CloseCircleOutlined />;
}

export default Icon;
